module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 37
// module chunks = 0